// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X9aV","controls":"styles_controls__2jxQQ","charLimit":"styles_charLimit__3olhq","input":"styles_input__2LTu-","send":"styles_send__3KACr"};